import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { getImagePath } from '../../utils/index';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const ImgFallback = ({ fallback, src, alt,ariaHidden,...otherProps }) => {
  const [img, setImg] = useState(src);
  const [altText, setAltText] = useState(alt);
  const isFirst = useRef(true);
  const handleFailure = () => {
    console.log('Image with url failed to load -> ', src);
    const altTxt = 'Image Failure placeholder;'
    let fallbackURL = !fallback ? 'fleek-post-image-placeholder.png' : fallback;
    if (fallback === 'logo') {
      fallbackURL = 'fleek-brand-logo-placeholder.png';
      // setAltText('Loading');
    } else if (fallback === 'image') {
      fallbackURL = 'fleek-post-image-placeholder.png';
    }
    setImg(getImagePath(fallbackURL));
    setAltText(altTxt)
  };

 



  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    // console.log('UseEffect triggered ImgFallback with src -> ', src)
    setImg(src);
  }, [src]);
  return (
    <img
      id="has-fallback"
      {...otherProps}
      src={replaceWithJioCDN(img) || ''}
      onError={handleFailure}
      alt={altText || 'fallback image'}
      aria-hidden={ariaHidden ? true : undefined}
    />
  );
};

export default ImgFallback;
